// authStorage.js

export class VMAuthStorage {
  static AUTH_KEYS = {
    EMAIL: 'emailForSignIn',
    AUTH_URL: 'pendingAuthUrl',
    AUTH_TOKEN: 'authToken',
    FIREBASE_USER_ID: 'firebaseUserId',
    SYSTEM_USER_ID: 'systemUserId',
    TEMP: 'temp'
  };

  // Store email for sign-in process
  static setSignInEmail(email) {
    console.log("AuthStorage setting signIn Email:", email);
    if (!email) {
      console.warn("Attempting to set null/undefined email");
      return;
    }
    try {
      localStorage.setItem(this.AUTH_KEYS.EMAIL, email);
      console.log("Email stored successfully");
    } catch (error) {
      console.error("Error storing email:", error);
    }
  }

  static setPendingAuthUrl(url) {
    console.log("AuthStorage setting pending auth URL:", url);
    if (!url) {
      console.warn("Attempting to set null/undefined auth URL");
      return;
    }
    try {
      localStorage.setItem(this.AUTH_KEYS.AUTH_URL, url);
      console.log("Auth URL stored successfully");
    } catch (error) {
      console.error("Error storing auth URL:", error);
    }
  }

  // Store auth data after successful sign-in
  static setAuthData(token, firebaseUserId) {
    //console.log("AuthStorage setting auth data: ", { token, firebaseUserId });
    localStorage.setItem(this.AUTH_KEYS.AUTH_TOKEN, token);
    localStorage.setItem(this.AUTH_KEYS.FIREBASE_USER_ID, firebaseUserId);
  }

  // Get stored email
  static getSignInEmail() {
    const email = localStorage.getItem(this.AUTH_KEYS.EMAIL);
    console.log("Retrieved stored email:", email);
    return email;
  }

  static getPendingAuthUrl() {
    const url = localStorage.getItem(this.AUTH_KEYS.AUTH_URL);
    //console.log("Retrieved stored auth URL:", url);
    return url;
  }

  // Get stored auth token
  static getAuthToken() {
    return localStorage.getItem(this.AUTH_KEYS.AUTH_TOKEN);
  }

  // Get stored user ID
  static getFirebaseUserId() {
    return localStorage.getItem(this.AUTH_KEYS.FIREBASE_USER_ID);
  }

  static setSystemUserId(systemUserId) {
    console.log("AuthStorage setting systemUserId: ", systemUserId);
    localStorage.setItem(this.AUTH_KEYS.SYSTEM_USER_ID, systemUserId);
  }

  // New method to get system user ID
  static getSystemUserId() {
    return localStorage.getItem(this.AUTH_KEYS.SYSTEM_USER_ID);
  }

  // Check if we have pending auth data
  static hasPendingAuth() {
    return !!(this.getSignInEmail() && this.getPendingAuthUrl());
  }

  // Clear sign-in related data
  static clearSignInData() {
    console.log("Clearing sign-in data");
    try {
      localStorage.removeItem(this.AUTH_KEYS.EMAIL);
      localStorage.removeItem(this.AUTH_KEYS.AUTH_URL);
      console.log("Sign-in data cleared successfully");
    } catch (error) {
      console.error("Error clearing sign-in data:", error);
    }
  }

  // Clear all auth data
  static clearAllAuthData() {
    console.log("Clearing all auth data");
    try {
      Object.values(this.AUTH_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
      console.log("All auth data cleared successfully");
    } catch (error) {
      console.error("Error clearing all auth data:", error);
    }
  }
  static getTemp() {
    return localStorage.getItem(this.AUTH_KEYS.TEMP);
  }

  // Log current auth state - useful for debugging
  static logAuthState() {
    console.log('Current Auth State:', {
      email: this.getSignInEmail(),
      pendingUrl: this.getPendingAuthUrl(),
      token: this.getAuthToken() ? '[PRESENT]' : '[NONE]',
      firebaseUserId: this.getFirebaseUserId(),
      systemUserId: this.getSystemUserId(),
      temp: this.getTemp()
    });
    console.log('Current origin:', window.location.origin);
  }
}

//export default AuthStorage;
